import { useMemo } from 'react';
import { useAccountContext } from '@gonfalon/app-context/useAccountContext';

import { LimitNames } from '../../types';
import { getSubscriptionLimits } from '../utils/getSubscriptionLimits';
import { getVisibleUsageTabs, isDataExportCombinedTabEnabled } from '../utils/getVisibleUsageTabs';
import { hasSubscriptionLimit } from '../utils/hasSubscriptionLimit';

import { useDataExportSourceCapabilities } from './useDataExportSourceCapabilities';

function useWarehouseDataExportPresence(limits: ReturnType<typeof getSubscriptionLimits>) {
  const enabled =
    isDataExportCombinedTabEnabled() && !hasSubscriptionLimit(limits?.[LimitNames.EVENTS_PUBLISHED] ?? null);
  const capabilities = useDataExportSourceCapabilities({ enabled });

  return {
    hasWarehouseDataExport:
      enabled && (capabilities.data ? capabilities.data.warehouse.configured === true : capabilities.isError === true),
    isPending: enabled && capabilities.isLoading,
  };
}

export function useVisibleUsageTabs() {
  const { subscription } = useAccountContext();
  const limits = getSubscriptionLimits(subscription);
  const { hasWarehouseDataExport, isPending } = useWarehouseDataExportPresence(limits);
  const tabs = useMemo(() => getVisibleUsageTabs(limits, { hasWarehouseDataExport }), [limits, hasWarehouseDataExport]);

  return { tabs, isPending };
}
